import { Dialog } from '@infotech-soe/erp-ui-kit';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import SchemaPreferencesPaneContainer from './SchemaPreferencesPaneContainer';
import ThemePreferencesPaneContainer from './ThemePreferencesPaneContainer';

const messages = defineMessages({
  title: {
    id: 'core.preferencesDialog.title',
    defaultMessage: 'Preferences',
  },
});

interface Props {
  open: boolean;
  onClose: () => void;
}

const PreferencesDialog: React.FC<Props> = ({ open, onClose }) => {
  const intl = useIntl();

  return (
    <Dialog
      title={intl.formatMessage(messages.title)}
      open={open}
      onClose={onClose}
      height="auto"
      width={450}
    >
      <ThemePreferencesPaneContainer />
      <SchemaPreferencesPaneContainer />
    </Dialog>
  );
};

export default PreferencesDialog;
